import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GETUpdateMeterComponent } from '../update-meter/get-update-meter.component';
import { EquipmentDetailsService } from '../../equipment-details.service';
import { ChangeMeterUnitModel } from '../../equipment-details.model';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-meter-unit',
  templateUrl: './change-meter-unit.component.html',
  styleUrls: ['./change-meter-unit.component.scss']
})
export class GETChangeMeterUnitComponent implements OnInit {

LtdReading:number
  oldMeterSMUReading: number;
  newSMUReadingOnNewMeter: number;
  dateReplaced: Date = new Date();
  saving = false;
  private _equipmentId: number;
  private _subscriptions: Subscription[] = [];
  selectedCustomer: number;

  changeMeterForm: FormGroup;
  oldsmuReadingInput: FormControl;
  newsmuReadingInput: FormControl;

  constructor(public dialogRef: MatDialogRef<GETUpdateMeterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _equipment: EquipmentDetailsService,
    public toastr: NotificationsService, vRef: ViewContainerRef,
  ) {
  
  }

  ngOnInit() {
    this.selectedCustomer = this.data.customerId;
    this._equipmentId = this.data.equipmentId;
    this.LtdReading=this.data.Ltd;
    this.createFormControls(this.data.smuPrechange);
    this.createForm();
  }

  changeMeterUnitClicked(): void {
    this.saving = true;
    const changeUnitModel = new ChangeMeterUnitModel();
    changeUnitModel.newSMUReadingOnNewMeter = this.newSMUReadingOnNewMeter;
    changeUnitModel.oldMeterSMUReading = this.oldMeterSMUReading;
    changeUnitModel.equipmentId = this._equipmentId;
    changeUnitModel.dateReplaced = this.dateReplaced;
    changeUnitModel.Ltd=this.LtdReading


    this._subscriptions.push(this._equipment.changeMeterUnit(changeUnitModel).subscribe(succeeded => {
        this.saving = false;
        console.log(succeeded.m_Item2)
      if (succeeded.m_Item1) {
          this.toastr.success('Meter Unit changed', 'This equipment meter has been successfully changed.');
          this.dialogRef.close(succeeded.m_Item1);
      } else {
        this.toastr.error(succeeded.m_Item2);
      }
    }));
  }

  createFormControls(preChangeMeterSMU: number) {
    this.oldsmuReadingInput = new FormControl('', [
      Validators.required,
      Validators.min(preChangeMeterSMU),
    ]);

    this.newsmuReadingInput  =  new FormControl('', [
      Validators.required,
    ]);
  }
  createForm() {
    this.changeMeterForm = new FormGroup({
      oldsmuReadingInput: this.oldsmuReadingInput,
      newsmuReadingInput : this.newsmuReadingInput,
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
